import { createAction } from '@reduxjs/toolkit'
import { ModalConfirmFields } from './modal-confirm.reducer'

export const setModalConfirmVisible = createAction<boolean>('modalAddFields/setModalConfirmVisible')
export const showModalConfirm = createAction<ModalConfirmFields>('modalAddFields/showModalConfirm')
export const resetModalConfirm = createAction('modalAddFields/resetModalConfirm')
